import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-update-predefined-parameter',
  templateUrl: './update-predefined-parameter.component.html',
  styleUrls: ['./update-predefined-parameter.component.css']
})
export class UpdatePredefinedParameterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
